import type { Toast } from "./types";

export const getToastStyles = (toast: Toast) => {
  switch (toast.type) {
    case "success":
      return "bg-global-success border text-global-success";
    case "error":
      return "bg-global-error border text-global-error";
    case "warning":
      return "bg-global-warning border text-global-primary";
    case "info":
      return "bg-global-info border text-global-primary";
    case "loading":
      return "bg-global-overlay-secondary border border-global-secondary text-global-secondary";
    default:
      return "bg-global-overlay-secondary border border-global-secondary text-global-secondary";
  }
};

export const getIcon = (toast: Toast) => {
  switch (toast.type) {
    case "success":
      return (
        <svg
          className="w-5 h-5 sm:w-6 sm:h-6 text-global-success shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      );
    case "error":
      return (
        <svg
          className="w-5 h-5 sm:w-6 sm:h-6 text-global-error flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    case "warning":
      return (
        <svg
          className="w-5 h-5 sm:w-6 sm:h-6 text-global-primary flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      );
    case "info":
      return (
        <svg
          className="w-5 h-5 sm:w-6 sm:h-6 text-global-primary flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    case "loading":
      return (
        <svg
          className="w-5 h-5 sm:w-6 sm:h-6 text-global-secondary flex-shrink-0 animate-spin"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      );
    default:
      return null;
  }
};
